(function () {
  "use strict";

  function init() {
    const modal = document.getElementById("ai-cart-preview-modal");
    if (!modal || modal.dataset.bound === "true") return;
    modal.dataset.bound = "true";

    const imagesHost = document.getElementById("ai-cart-preview-modal-images");

    function closeModal() {
      if (modal.open) {
        modal.close();
      } else {
        modal.hidden = true;
        modal.setAttribute("aria-hidden", "true");
      }
      if (imagesHost) imagesHost.innerHTML = "";
      document.body.classList.remove("ai-cart-preview-modal-open");
    }

    function openModal(src) {
      if (!src || !imagesHost) return;

      imagesHost.innerHTML = `<img class="ai-cart-preview-modal__image" src="${src}" alt="Design preview" loading="lazy">`;

      if (typeof modal.showModal === "function" && !modal.open) {
        modal.showModal();
      } else {
        modal.hidden = false;
        modal.setAttribute("aria-hidden", "false");
      }
      document.body.classList.add("ai-cart-preview-modal-open");
    }

    modal.addEventListener("click", (event) => {
      if (event.target.closest("[data-ai-preview-close]")) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.target === modal) {
        closeModal();
      }
    });

    modal.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeModal();
    });

    modal.addEventListener("close", () => {
      if (imagesHost) imagesHost.innerHTML = "";
      document.body.classList.remove("ai-cart-preview-modal-open");
    });

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-ai-preview-src]");
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(trigger.getAttribute("data-ai-preview-src"));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
